module.exports = __webpack_public_path__ + "img/follow-us-2.6de66b5a.jpg";